import React from 'react';
import PropTypes from 'prop-types';
import { BrowserOnly, PrintOnly } from 'cccisd-laravel-report';
import OverallValue from './OverallValue';
import ShowValue from './ShowValue';
import style from './style.css';

const Callout = props => {
    const { title, description, colors } = props.settings;

    const _renderCalloutComponent = handle => {
        return (
            <>
                <BrowserOnly>
                    <OverallValue data={props.data} colors={colors} settings={props.settings} />
                </BrowserOnly>
                <PrintOnly>
                    <ShowValue data={props.data.overallFidelity} colors={colors} />
                </PrintOnly>
            </>
        );
    };

    return (
        <div
            className={style.wrapper}
            style={
                colors
                    ? {
                          border: `1px solid ${colors.primary}`,
                      }
                    : {}
            }
        >
            <div
                className={style.title}
                style={
                    colors
                        ? {
                              backgroundColor: colors.primary,
                          }
                        : {}
                }
            >
                {title}
            </div>
            <div className={style.description}>{description}</div>
            <div className={style.component}>{_renderCalloutComponent(props.handle)}</div>
        </div>
    );
};

Callout.propTypes = {
    settings: PropTypes.object,
    handle: PropTypes.string,
    data: PropTypes.object,
    overallFidelity: PropTypes.number,
};

Callout.defaultProps = {
    settings: { title: 'Overall Fidelity', description: 'Across selected group(s)' },
};

export default Callout;
